import Icon from '@/components/common/Icon.tsx'
import { cn } from '@/lib/utils.ts'

type PropsT = {
  fallbackMessage: string
  onClick?: () => void
  className?: string
}

export default function SelectFallback({ fallbackMessage, onClick, className }: PropsT) {
  return (
    <>
      <button
        onClick={onClick}
        className={cn('flex w-full gap-2 px-4 pb-2 pt-4 text-xs text-accent-foreground', className)}
      >
        <Icon icon={`info`} className={`size-4 shrink-0`} />
        <span className={`text-left`}>{fallbackMessage}</span>
      </button>
    </>
  )
}
